import React, { Component } from "react";
import axios from "axios";
import { Navigate } from "react-router-dom";

import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";
import {
  apiErrorMessage,
  firstError,
  hasErrors,
  slugify,
  validateSitePage,
} from "Helpers/ContentValidation";
import { emptyPageForm, pageFormToPayload } from "Helpers/ContentPayloads";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { Card, Divider } from "@mui/material";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";

import PageFormFields from "components/ContentForms/PageFormFields";
import SectionEditor from "components/ContentForms/SectionEditor";

export default class AddSitePage extends Component {
  state = {
    values: emptyPageForm(),
    errors: {},
    slugTouched: false,

    loading: false,
    notification: false,
    notiColor: "success",
    message: "",
    redirect: false,
  };

  handleChange = (name, value) => {
    this.setState((state) => {
      const values = { ...state.values, [name]: value };

      if (name === "name" && !state.slugTouched) {
        values.slug = slugify(value);
      }

      const errors = { ...state.errors };
      delete errors[name];

      return {
        values,
        errors,
        slugTouched: name === "slug" ? true : state.slugTouched,
      };
    });
  };

  handleSectionsChange = (sections) => {
    this.setState((state) => ({ values: { ...state.values, sections } }));
  };

  notify = (notiColor, message) => {
    this.setState({ notification: true, notiColor, message });
    setTimeout(() => this.setState({ notification: false, message: "" }), 4000);
  };

  handleSubmit = async (event) => {
    event.preventDefault();

    const errors = validateSitePage(this.state.values, { isUpdate: false });
    if (hasErrors(errors)) {
      this.setState({ errors });
      return this.notify("warning", firstError(errors));
    }

    if (init() !== "success") return this.setState({ redirect: true });

    this.setState({ loading: true, errors: {} });

    try {
      const response = await axios.post(
        Constants.postUrls.createSitePage,
        pageFormToPayload(this.state.values)
      );

      this.setState({ loading: false });
      this.notify("success", response.data?.message || "Page created successfully!");
      setTimeout(() => this.setState({ redirect: true }), 1200);
    } catch (error) {
      this.setState({ loading: false });
      this.notify("warning", apiErrorMessage(error, "Could not create the page"));
    }
  };

  render() {
    if (this.state.redirect) return <Navigate to="/sitepages" replace />;

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Add Website Page
              </MDTypography>
            </MDBox>

            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit} noValidate>
                <PageFormFields
                  values={this.state.values}
                  errors={this.state.errors}
                  onChange={this.handleChange}
                />

                <MDBox mt={3} mb={2}>
                  <Divider />
                </MDBox>

                <SectionEditor
                  sections={this.state.values.sections}
                  onChange={this.handleSectionsChange}
                  errors={this.state.errors}
                  onError={(message) => this.notify("warning", message)}
                />

                <MDBox mt={4} display="flex" gap={2}>
                  <MDButton
                    type="submit"
                    variant="gradient"
                    color="info"
                    disabled={this.state.loading}
                  >
                    {this.state.loading ? "Saving..." : "Create Page"}
                  </MDButton>

                  <MDButton
                    variant="outlined"
                    color="dark"
                    onClick={() => this.setState({ redirect: true })}
                    disabled={this.state.loading}
                  >
                    Cancel
                  </MDButton>
                </MDBox>
              </form>
            </MDBox>

            <MDSnackbar
              color={this.state.notiColor}
              icon="notifications"
              title="Website Pages"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
              close={() => this.setState({ notification: false })}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
